module.exports = __webpack_public_path__ + "static/media/ui_ux_design.2b0e4efc.svg";